import { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const RegisterLazy = lazyLoader(
  () => import('./Register' /* webpackChunkName: "register" */),
);

const Login = () => {
  return (
    <Suspense fallback={null}>
      <RegisterLazy />
    </Suspense>
  );
};

export default Login;
